/**
 * The signed-in user, top right of the shell: initials in a round avatar that
 * opens a menu with who is signed in and Sign out.
 */

import { useCallback, useRef, useState } from "react";
import { useAuth } from "../auth/AuthProvider.jsx";
import { Icon, popoverClass, useDismiss } from "../components/ui/index.js";

export function UserMenu() {
  const { me, signOut } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useDismiss(ref, open, useCallback(() => setOpen(false), []));
  const name = me?.dev ? "Local dev" : `User ${me?.sub ?? ""}`;
  const initials = me?.dev ? "LD" : "U";
  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={`Account: ${name}`}
        title={me?.dev ? "Local development: sign-in disabled" : `Signed in · user ${me?.sub ?? ""}`}
        className="grid size-10 place-items-center rounded-full bg-accent-soft text-[12px] font-semibold text-accent-ink ring-2 ring-surface-1 transition-shadow hover:shadow-card-hover"
      >
        {initials}
      </button>
      {open && (
        <div role="menu" className={`absolute top-full right-0 mt-2 w-60 p-1.5 ${popoverClass}`}>
          <div className="px-3 pt-2 pb-2.5">
            <p className="truncate text-[13.5px] font-semibold text-ink">{name}</p>
            <p className="text-[12px] text-ink-3">Role-scoped access</p>
          </div>
          <div className="my-1 h-px bg-line" />
          <button type="button" role="menuitem" onClick={signOut} className="flex w-full items-center gap-2.5 rounded-control px-3 py-2.5 text-left text-[13.5px] text-ink-2 hover:bg-surface-2 hover:text-ink">
            <Icon name="logout" className="size-4" />
            Sign out
          </button>
        </div>
      )}
    </div>
  );
}
